class GoogleMapElement {
  constructor($main) {
    console.log('GoogleMapElement');

    this.initDomElements($main);
    this.setupEventListeners();
  }

  initDomElements($main) {
    this.domElements = {};
    this.domElements.main = $main;
    if (this.domElements.main.length < 1) return false;

    this.domElements.mapContainer = this.domElements.main.find('.googlemap__map-container');
    this.domElements.map = this.domElements.main.find('.googlemap__map');
    this.domElements.previewImage = this.domElements.main.find('.googlemap__preview-image');
    this.domElements.btn = this.domElements.main.find('.googlemap__advice');
    this.domElements.mapItems = this.domElements.main.find('.googlemap__map-item');

    return true;
  }

  setupEventListeners() {
    if (this.domElements.previewImage) {
      this.domElements.previewImage.on('click', () => {
        this.loadMap();
      });
    }

    if (this.domElements.btn) {
      this.domElements.btn.on('click', () => {
        this.loadMap();
      });
    }

    window.addEventListener('cookieConsent', event => {
      console.log('cookie consent', event);

      if (event.detail.hasOption('google_maps')) {
        this.loadMap();
      }
    });
  }

  loadMap() {
    // Hide preview image and button
    if (this.domElements.previewImage.length) {
      this.domElements.previewImage.fadeOut();
    }

    if (this.domElements.btn.length) {
      this.domElements.btn.fadeOut();
    }

    // Show map container
    this.domElements.mapContainer.addClass('googlemap__map-container--active');

    // Load Google Maps API and initialize map
    this.loadGoogleMapsAPI();
  }

  loadGoogleMapsAPI() {
    // Check if Google Maps API is already loaded
    if (window.google && window.google.maps) {
      this.initMap();
      return;
    }

    // Create script element
    const script = document.createElement('script');
    script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDJ3PR9zDp0K3ZfsXNxxDJc4-OjP7ZCNQQ&callback=initMap&loading=async';
    script.async = true;
    script.defer = true;

    // Define global callback function
    window.initMap = () => {
      this.initMap();
    };

    // Append script to document
    document.head.appendChild(script);
  }

  initMap() {
    const mapId = this.domElements.map.attr('id');
    const latLng = [];

    // Read map items from data attributes
    this.domElements.mapItems.each((index, item) => {
      const $item = $(item);
      latLng.push({
        lat: parseFloat($item.data('latitude')),
        lng: parseFloat($item.data('longitude')),
        title: $item.data('title')
      });
    });

    if (latLng.length === 0) {
      console.error('No map items found');
      return;
    }

    // Create map
    const map = new google.maps.Map(document.getElementById(mapId), {
      zoom: 14,
      center: latLng[0]
    });

    // Add markers
    latLng.forEach((item, index) => {
      new google.maps.Marker({
        position: item,
        title: item.title,
        map: map
      });
    });

    // Trigger resize event to ensure map is properly displayed
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 100);
  }
}

export default GoogleMapElement;
